var map = {
	"./amagrar_logo.png": 75710,
	"./kulturen/Apfel.png": 53926,
	"./kulturen/Erdbeere.png": 29042,
	"./kulturen/Hafer.png": 33064,
	"./kulturen/Kartoffeln.png": 77909,
	"./kulturen/Möhren.png": 65676,
	"./kulturen/RoteBeete.png": 28322,
	"./kulturen/Sellerie.png": 93015,
	"./kulturen/Sommerweizen.png": 17932,
	"./kulturen/Spargel.png": 50908,
	"./kulturen/Winterdurum.png": 12007,
	"./kulturen/Wintergerste.png": 98589,
	"./kulturen/Winterraps.png": 6996,
	"./kulturen/Winterroggen.png": 87741,
	"./kulturen/Wintertriticale.png": 25679,
	"./kulturen/Winterweizen.png": 16528,
	"./kulturen/Zuckerrüben.png": 63522,
	"./kulturen/Zwiebeln.png": 21874,
	"./kulturen/default.png": 31526,
	"./logo.png": 66949,
	"./navigation/Prognosen.png": 88183,
	"./navigation/Rueckmeldung.png": 6774,
	"./navigation/Wetter.png": 16846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92715;